import { render, staticRenderFns } from "./SvgWorldMap.vue?vue&type=template&id=364f2d11&scoped=true"
import script from "./SvgWorldMap.vue?vue&type=script&lang=js"
export * from "./SvgWorldMap.vue?vue&type=script&lang=js"
import style0 from "./SvgWorldMap.vue?vue&type=style&index=0&id=364f2d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364f2d11",
  null
  
)

export default component.exports